import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/modules/directives.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { TimeFormControlModule } from '@app/modules/time-form-control/time-form-control.module';
import { IonicModule } from '@ionic/angular';
import { TodaysShiftModalComponent } from './todays-shift-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    TimeFormControlModule,
    FormsModule,
    ReactiveFormsModule,
    FullHeightContainerModule
  ],
  exports: [TodaysShiftModalComponent],
  declarations: [TodaysShiftModalComponent]
})
export class TodaysShiftModalModule {}
